module.exports = __webpack_public_path__ + "img/sign-bg.2c9b1049.png";